(function() {
  define('bazemont/content/pageNewSection',['angular'], function() {
    'use strict';
    return angular.module('bazemontContentPageNewSection', []).component('bazemontContentPageNewSection', {
      templateUrl: '/assets/javascripts/bazemont/content/pageNewSection.html',
      bindings: {
        position: '<'
      },
      require: {
        parent: '^^bazemontContentPage'
      },
      controller: [
        function() {
          var vm;
          vm = this;
          vm.addNewSection = function(position) {
            return vm.parent.addNewSection(position);
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=pageNewSection.js.map
;
